const normalizeHiddenProducts = (hiddenProducts?: number[]) =>
  (hiddenProducts ?? []).map((id) => Number(id)).filter((id) => !Number.isNaN(id))

export function getVisibleCategories(categories: any[] = [], hiddenProducts?: number[]) {
  const hiddenProductsSet = new Set(normalizeHiddenProducts(hiddenProducts))

  return categories.filter((category) => {
    if (category?.category?.attributes?.hide_products) {
      return false
    }

    const products = category?.products ?? []

    if (products.length === 0) {
      return true
    }

    return products.some((product: any) => {
      const productId = Number(product?.product?.attributes?.product_id)

      if (Number.isNaN(productId)) {
        return false
      }

      return !hiddenProductsSet.has(productId)
    })
  })
}
